import Avatar from '../components/Avatar';

// Group picture: the uploaded icon, or two overlapping member avatars
export default function GroupAvatar({ icon, members = [], size = 36 }) {
  if (icon) {
    return (
      <img src={icon} alt="" width={size} height={size} className="shrink-0 rounded-full object-cover" style={{ width: size, height: size, border: '1.5px solid var(--purple-dim)' }} />
    );
  }
  const [a, b] = members;
  const small = Math.round(size * 0.68);
  if (!b) return <Avatar src={a?.avatar} size={size} />;
  return (
    <div className="relative shrink-0" style={{ width: size, height: size }} aria-hidden="true">
      <div className="absolute left-0 top-0"><Avatar src={a?.avatar} size={small} /></div>
      <div className="absolute bottom-0 right-0 rounded-full" style={{ boxShadow: '0 0 0 2px var(--surface)' }}><Avatar src={b?.avatar} size={small} /></div>
    </div>
  );
}
